import React, { useEffect, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { HomeOne, News, Page, Services } from "./Menu";
import DropDown from "./DropDown";
import Logo from "../../assets/images/logo.png";

export default function Header({ variant }) {
    const [isSticky, setIsSticky] = useState(false);
    const [mobileToggle, setMobileToggle] = useState(false);

    useEffect(() => {
        window.addEventListener("scroll", () => {
            if (window.scrollY > 0) {
                setIsSticky(true);
            } else {
                setIsSticky(false);
            }
        });
    }, []);

    return (
        <>
            <header className={`main-header header__style__one two ${variant ? variant : ""} header__sticky ${isSticky ? "fixed-header" : ""}`}>
                <div className="header-lower">
                    <div className="auto-container">
                        <div className="outer-box">
                            <div className="logo-box">
                                <figure className="logo">
                                    <Link to="/"><img src={Logo} width="100" height="80" alt="" /></Link>
                                </figure>
                            </div>
                            <div className="menu-area clearfix">
                                <div className={mobileToggle ? "mobile-menu-visible" : "mobile-menus"} >
                                    <div className="mobile-nav-toggler" onClick={() => setMobileToggle(!mobileToggle)}>
                                        <i className="icon-bar"></i>
                                        <i className="icon-bar"></i>
                                        <i className="icon-bar"></i>
                                    </div>
                                    <div className="mobile-menu">
                                        <div className="menu-backdrop"></div>
                                        <div className="close-btn" onClick={() => setMobileToggle(!mobileToggle)}><i className="icon-fa-times"></i></div>

                                        <nav className="menu-box">
                                            <div className="nav-logo">
                                                <Link to="/"><img src={Logo} width="100" height="80" alt="" title="" /></Link>
                                            </div>
                                            <div className="menu-outer">
                                                <div className="collapse navbar-collapse show clearfix" id="navbarSupportedContent">
                                                    <ul className="navigation clearfix HomeOne-menu">
                                                        <li className="dropdown" >
                                                            <NavLink to="/">HomeOne</NavLink>
                                                            <DropDown>
                                                                <ul>
                                                                    <HomeOne />
                                                                </ul>
                                                            </DropDown>
                                                        </li>
                                                        <li >
                                                            <NavLink to="/about">About</NavLink>
                                                        </li>
                                                        <li className="dropdown" >
                                                            <NavLink to="/services">Services</NavLink>
                                                            <DropDown>
                                                                <ul>
                                                                    <Services />
                                                                </ul>
                                                            </DropDown>
                                                        </li>
                                                        <li className="dropdown" >
                                                            <NavLink to="/projects">Industry</NavLink>
                                                            {/* <DropDown>
                                                                <ul>
                                                                <Page />
                                                                </ul>
                                                            </DropDown> */}
                                                        </li>
                                                        {/* <li className="dropdown" >
                                                            <NavLink to="/blog">Resources</NavLink>
                                                            <DropDown>
                                                                <ul>
                                                                <News />
                                                                </ul>
                                                            </DropDown>
                                                        </li>   */}
                                                        <li >
                                                            <NavLink to="/contact">Contact</NavLink>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                            <div className="contact-info">
                                                <h4>Contact Info</h4>
                                                <ul>
                                                    <li>GS Road, Guwahati, Assam</li>
                                                    <li><Link to="tel:+91-8295968888">+91-8295968888</Link></li>
                                                    <li><Link to="mailto:info@maticresearch.com">info@maticresearch.com</Link></li>
                                                </ul>
                                            </div>
                                        </nav>
                                    </div>
                                </div>
                                <nav className="main-menu navbar-expand-md navbar-light">
                                    <div className="collapse navbar-collapse show clearfix" id="navbarSupportedContent">
                                        <ul className="navigation clearfix HomeOne-menu">
                                            <li className="dropdown" >
                                                <NavLink to="/">HomeOne</NavLink>
                                                <DropDown>
                                                    <ul>
                                                        <HomeOne />
                                                    </ul>
                                                </DropDown>
                                            </li>
                                            <li >
                                                <NavLink to="/about">About</NavLink>
                                            </li>
                                            <li className="dropdown" >
                                                <NavLink to="/services">Services</NavLink>
                                                <DropDown>
                                                    <ul>
                                                        <Services />
                                                    </ul>
                                                </DropDown>
                                            </li>
                                            <li className="dropdown" >
                                                <NavLink to="/projects">Industry</NavLink>
                                                {/* <DropDown>
                                                    <ul>
                                                        <Page />
                                                    </ul>
                                                </DropDown> */}
                                            </li>
                                            {/* <li className="dropdown" >
                                                <NavLink to="/blog">Resources</NavLink>
                                                <DropDown>
                                                    <ul>
                                                        <News />
                                                    </ul>
                                                </DropDown>
                                            </li>   */}
                                            <li >
                                                <NavLink to="/contact">Contact</NavLink>
                                            </li>
                                        </ul>
                                    </div>
                                </nav>
                            </div>
                            <div className="btn-box">
                                <Link to="/contact" className="theme-btn theme-btn-one"><i className="icon-02"></i> Discuses</Link>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="sticky-header">
                    <div className="auto-container">
                        <div className="outer-box">
                            <div className="logo-box">
                                <figure className="logo"><Link to="/"><img src={Logo} width="160" height="120" alt="" /></Link></figure>
                            </div>
                            <div className="menu-area clearfix">
                                <nav className="main-menu clearfix">
                                    <div className="collapse navbar-collapse show clearfix" id="navbarSupportedContent">
                                        <ul className="navigation clearfix HomeOne-menu">
                                            <li className="dropdown" >
                                                <NavLink to="/">HomeOne</NavLink>
                                                <DropDown>
                                                    <ul>
                                                        <HomeOne />
                                                    </ul>
                                                </DropDown>
                                            </li>
                                            <li >
                                                <NavLink to="/about">About</NavLink>
                                            </li>
                                            <li className="dropdown" >
                                                <NavLink to="/services">Services</NavLink>
                                                <DropDown>
                                                    <ul>
                                                        <Services />
                                                    </ul>
                                                </DropDown>
                                            </li>
                                            <li className="dropdown" >
                                                <NavLink to="/projects">Industry</NavLink>
                                                {/* <DropDown>
                                                    <ul>
                                                        <Page />
                                                    </ul>
                                                </DropDown> */}
                                            </li>
                                            {/* <li className="dropdown" >
                                                <NavLink to="/blog">Resources</NavLink>
                                                <DropDown>
                                                    <ul>
                                                        <News />
                                                    </ul>
                                                </DropDown>
                                            </li>   */}
                                            <li >
                                                <NavLink to="/contact">Contact</NavLink>
                                            </li>
                                        </ul>
                                    </div>
                                </nav>
                            </div>
                            <div className="btn-box">
                                <Link to="/contact" className="theme-btn theme-btn-one"><i className="icon-02"></i> Discuses</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </header>

        </>
    );
}
